import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { ISanitizer } from '~commonInfra/utils/Sanitize';

import { Messages } from '../../../codegen/Localize';
import { L10n } from '../../../commonInfra/L10n/L10n';
import { TextileHelper } from '../../utils/TextileHelper';
import { SpaceHeaderTestIds } from './SpaceHeader';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

export const maxDescriptionLength = 180;

export function ItemDescription(
  item: { description: string },
  openDetail: () => void,
  sanitizer: ISanitizer
): JSX.Element {
  let descriptionPlaintext = TextileHelper.getPlainTextFromTextile(item.description, sanitizer);
  let isDescriptionLong = descriptionPlaintext.length > maxDescriptionLength;

  if (_.isEmpty(descriptionPlaintext)) {
    return null;
  }

  return (
    <div data-tb-test-id={SpaceHeaderTestIds.description} className={SpaceHeaderStyles.ItemDescription}>
      {L10n.elideIfLong(descriptionPlaintext, maxDescriptionLength)}
      {isDescriptionLong && <ReadMoreLink onClick={openDetail} />}
    </div>
  );
}

export interface ReadMoreButtonProps {
  readonly onClick: () => void;
}

export function ReadMoreLink(props: ReadMoreButtonProps) {
  return <ButtonWidget
    buttonType={ButtonType.LowEmphasis}
    children={Messages.description_readMore()}
    onClick={props.onClick}
    style={{ height: 'unset', marginLeft: 4 }}
    testId={SpaceHeaderTestIds.readMore}
  />;
}
